import { IHttpClient } from '@wix/http-client';
import {
  ITemplateRepository,
  LoadTemplatesParams,
} from './proto/ITemplateRepository';
import { browseTemplates } from '@wix/ambassador-funnel-templates-gallery-v2-template/http';
import { mapAmbassadorTemplate, Template } from '../entities/template';

export class HttpTemplateRepository implements ITemplateRepository {
  constructor(private httpClient: IHttpClient) {}

  async loadTemplates(params: LoadTemplatesParams) {
    const { categoryId, language } = params;

    const {
      data: { templates },
    } = await this.httpClient.request(
      browseTemplates({
        categoryIds: [categoryId],
        language,
        limit: 100,
      }),
    );

    return templates?.map<Template>(mapAmbassadorTemplate) ?? [];
  }
}
